import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { errorClear, errorSet } from 'actions/error';
import { connectProvider, disconnectProvider } from 'actions/providers';

import Card from 'components/common/Card';
import LoadingSpinner from 'components/LoadingSpinner';

import { 
  Container,
  CardTitle,
  AICSAAvatar,
  FormsliveAvatar,
  InnerContainer
} from './Styled';

import { 
  EmptyState,
  ProviderListItem,
  useConnectDialog
} from './Connections';

import validate from './validation';

const ConnectionsContainer = (props) => {
  const updatedRef = useRef(props.lastUpdated);

  useEffect(() => {
    props.errorClear()
  }, []);

  const handleConnect = (data) => {
    props.errorClear();

    const [ isValid, errors ] = validate(data);

    if (isValid) {
      props.connectProvider(data);
    } else {
      props.errorSet({ inputErrors: errors });
    }
  }

  const handleDisconnect = (data) => {
    props.errorClear();
    props.disconnectProvider();
  }

  const [ renderConnectDialog, openConnect, closeConnect ] = useConnectDialog({ onSubmit: handleConnect });

  const handleOpen = () => {
    props.errorClear();
    openConnect();
  };

  useEffect(() => {
    if (updatedRef.current !== props.lastUpdated) {
      closeConnect();
    }
  }, [ props.lastUpdated])

  return (
    <Container>
      <InnerContainer>
          <Card.Content>
          <CardTitle>Third Party Access</CardTitle>

           {!props.loading && !props.loadingSession &&
            <React.Fragment>
            { 
              props.session.formslive_token &&
              <ProviderListItem
                name="Forms Live"
                avatar={FormsliveAvatar}
                onDisconnect={handleDisconnect}
              />
            }
            { 
              props.session.aic_token &&
              <ProviderListItem
                name="AICSA"
                avatar={AICSAAvatar}
                onDisconnect={handleDisconnect}
              />
            }
            {
              !props.session.formslive_token && 
              !props.session.aic_token &&
              <EmptyState onConnect={handleOpen} />
            }
            </React.Fragment>}
            {(props.loading || props.loadingSession) && <LoadingSpinner />}
        </Card.Content>
      </InnerContainer>
      {renderConnectDialog(props.loading, props.errorMessage, props.inputErrors)}
    </Container>
  );
};

const mapDispatchToProps = {
  connectProvider,
  errorClear,
  errorSet,
  disconnectProvider
};

const mapStateToProps = ({ providers, error, loading, session }) => ({
  session: session,
  errorMessage: error.message,
  lastUpdated: providers.updated,
  loading: loading.loadingConnect,
  inputErrors: error.inputErrors || {},
  loadingSession: loading.loadingSessionUpdate
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConnectionsContainer)
);
